<template>
  <div class=" px-4 justify-center  w-full">
    <div class="justify-center flex mb-4  max-w-[500px]">
      <span class="text-sm" v-html="value.message"></span>
    </div>
    <h1 class="p-1 text-lg">Märkte:</h1>
    <div class="flex overflow-auto">

      <div v-for="market in marketList" class="flex flex-col  ">
        <div class="bg-trader-gray p-4  flex text-center mr-2">
          <span class="mr-2">{{ market.name }}</span>
        </div>
      </div>
    </div>
    <div class="w-full flex gap-2 mb-2">
      <button class="bg-trader-green w-full rounded p-2 mt-2" @click="deleteFalse" data-ui="delete-no">OK</button>
    </div>
  </div>
</template>

<script>

import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import SignalBus from "@/application/SignalBus";
import {eventBus} from "@/application/EventBus.js";

export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      marketList: [],
    }
  },
  mounted() {
    this.getMarkets();
  },
  methods: {
    async getMarkets() {

      const query = gql`
        query getMarketsStatus($magazineId: Int!, $pagePosition: Int!) {
          getMarketsStatus(magazineId: $magazineId, pagePosition: $pagePosition)  {
            marketId
            name
            description
            isActive
            isFull
          }

        }
      `;
      try {
        const {data} = await apolloClient.query({
          query,
          variables: {magazineId: this.value.magazineId, pagePosition: this.value.pagePosition}
        });
        this.marketList = data.getMarketsStatus;

        // filter die Märkte mit der  value.marketIds
        this.marketList = this.marketList.filter(market => this.value.marketIds.includes(market.marketId));

      } catch (error) {
        console.error(error);
      }

    },
    deleteTrue() {
      eventBus.closeModal();

      try {
        if (this.value.onAccept) {
          this.value.onAccept();
        }
      } catch (e) {
      }

    },
    deleteFalse() {
      eventBus.closeModal();

      try {
        if (this.value.onCancel) {
          this.value.onCancel();
        }
      } catch (e) {
      }


    }
  },


}


</script>

